/**
 * return target for the 401 login button. The legacy server path lands here as
 * /401?ret=<original url>; the client-side path (addPageError(401) rendering
 * PubPage40x in place) has no ret param — the current location IS the target.
 */
export function resolveReturnUrl(url: URL): string {
	return url.searchParams.get('ret') || url.pathname + url.search
}

/** /login?redirect=<encoded return> — encode so & in nested query does not split the outer URL */
export function buildLoginRedirectHref(returnUrl: string): string {
	return `/login?redirect=${encodeURIComponent(returnUrl)}`
}
